import { HSLColor, contrastRatio } from '@yola/yola-palette-generator';
import constants from '../constants/custom-color-options';

const WHITE_HSL = new HSLColor(0, 0, 1);

const isLightColorType = (color) => contrastRatio(color, WHITE_HSL) < constants.LIGHT_CR;

export default isLightColorType;
